import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import apiFetch from '../../../utils/apiFetch';
import { notify } from '../../../utils/notification';
import { STEED_TYPES } from '../../../shared/rules/findSteed.mjs';

const BONUS_ACTIONS = { celestial: 'Healing Touch', fey: 'Fey Step', fiend: 'Fell Glare' };

/**
 * After a committed Find Steed cast, choose the steed's creature type. The server builds the Otherworldly Steed for
 * that cast's slot level and places it beside the caster as an ally (sharing their Initiative in combat).
 */
export default function FindSteedSummonModal({ castId, campaignId, characterId, onClose }) {
  const [pending, setPending] = useState(null);
  const [error, setError] = useState('');
  const choose = async (creatureType) => {
    setPending(creatureType); setError('');
    try {
      const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/summons/find-steed`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ characterId, castId, creatureType }),
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.message || 'The steed could not be summoned.');
      notify(body.placed === false
        ? `Your ${STEED_TYPES[creatureType].label} steed appears. There was no open space beside you, so ask the DM to place it.`
        : `Your ${STEED_TYPES[creatureType].label} steed appears beside you.`, 'success');
      onClose?.();
    } catch (failure) {
      setError(failure.message);
    } finally { setPending(null); }
  };
  return (
    <Modal show={Boolean(castId)} onHide={() => !pending && onClose?.()} centered>
      <Modal.Header closeButton><Modal.Title>Find Steed</Modal.Title></Modal.Header>
      <Modal.Body>
        <p>Choose your Otherworldly Steed’s creature type. It sets the damage its Otherworldly Slam deals and its Bonus Action.</p>
        <div className="d-grid gap-2">
          {Object.entries(STEED_TYPES).map(([type, { label, damageType }]) => (
            <Button key={type} variant="outline-light" disabled={Boolean(pending)} onClick={() => choose(type)}>
              {pending === type ? 'Summoning…' : `${label} · ${damageType[0].toUpperCase()}${damageType.slice(1)} damage · ${BONUS_ACTIONS[type]}`}
            </Button>
          ))}
        </div>
        {error && <p role="alert" className="text-warning mt-3 mb-0">{error}</p>}
      </Modal.Body>
    </Modal>
  );
}
